import { identifierFromString } from '@/lib/util'

export default class ZmanimListEntry {
  /**
   * Creates an object ready for display.
   * @param {String} key The KosherZmanim name of the zman.
   * @param {String} title The title of the zman.
   * @param {String} subtitle The subtitle, sometimes the rabbinic opinion.
   * @param {String} time The time to display.
   * @param {Date} date A date object representing the zman.
   */
  constructor ({ key, title, subtitle, time, date } = {}) {
    this.identifier = identifierFromString(title)
    this.key = key
    this.title = title
    this.subtitle = subtitle
    this.time = time
    this.date = date
  }

  entryType = 'default';
}
